import { Component, Input } from '@angular/core';
import { Monitor } from '../../core/models/entities/monitor.type';
import { Schedule } from '../../core/models/entities/schedule.type';
import { ScheduleSettingsDialogService } from '../../core/services/dialog-services/schedule-dialog.service';
import { ScheduleModalMode } from '../../core/enums/schedule-model-mode.enum';

@Component({
  selector: 'screen-schedule',
  templateUrl: './item-screen-schedule.component.html',
  styleUrls: ['./item-screen-schedule.component.scss'],
})

export class ScreenScheduleComponent {

  @Input() screen: Monitor;
  @Input() schedules: Schedule[];

  constructor(public scheduleModalService: ScheduleSettingsDialogService) { }

  edit(schedule) {
    this.scheduleModalService.show(schedule, schedule.On ? ScheduleModalMode.Edit : ScheduleModalMode.TurnOn);
  }

}
